import React, { useEffect, useState } from 'react';
import '../../styles/table-main/main.css';
import { getAllSportsCalendar } from '../../Services/AllAPIs';
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [sportsCalendar, setSportsCalendar] = useState([]);
    const [error, setError] = useState(null);

    // Fetch sports calendar data
    const getSportsCalendar = () => {
        getAllSportsCalendar()
            .then((res) => {
                const sportsCalendarData = Object.values(res.data.news || {});
                setSportsCalendar(sportsCalendarData);
                setLoader(false);
            })
            .catch((error) => {
                console.error(error);
                setError("An error occurred while fetching sports calendar data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getSportsCalendar();
    }, []);

    // Function to format date as DD-MM-YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
        <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        {loader && <LoadingSpinner />}
                        {error && <div className="error">{error}</div>}

                        <div className="col-md-12">
                            <div className="admin-table">
                                <h2 className="my-heading">Sports Calendar</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Posted Date</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sportsCalendar.length > 0 ? (
                                                sportsCalendar.map((event, index) => (
                                                    <tr key={index}>
                                                        <td>{event.title}</td>
                                                        <td>{formatDate(event.created_at)}</td>
                                                        <td>
                                                            <a
                                                                href={event.url}
                                                                className="btn btn-primary btn-download"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        No events found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
